/* Page-wide product attribution configured by the creator Garage section. */
(() => {
  if (window.hbrCreatorProductLinks) return;
  window.hbrCreatorProductLinks = true;
  const originals = new WeakMap();
  const written = new WeakMap();
  const normalizeHost = host => host.replace(/^www\./, '');
  const scan = () => {
    // One tracking configuration per page; the first enabled Garage wins.
    const config = [...document.querySelectorAll('[data-creator-tracking]')].find(el => el.dataset.utmSource.trim());
    let storeHost = '';
    try { storeHost = normalizeHost(new URL(config?.dataset.storeUrl).hostname); } catch {}
    document.querySelectorAll('a[href]').forEach(link => {
      const current = link.getAttribute('href');
      // Preserve updates from dialog playback, section reloads and other scripts.
      if (!written.has(link) || current !== written.get(link)) originals.set(link, current);
      const original = originals.get(link);
      let target = original;
      let url;
      try { url = new URL(original, location.href); } catch { return; }
      const host = normalizeHost(url.hostname);
      if (config && ['https:', 'http:'].includes(url.protocol) &&
          (host === normalizeHost(location.hostname) || host === storeHost) &&
          /\/products\/[^/]+/.test(url.pathname)) {
        ['source', 'medium', 'campaign'].forEach(key => {
          const value = config.dataset[`utm${key[0].toUpperCase()}${key.slice(1)}`].trim();
          if (value) url.searchParams.set(`utm_${key}`, value);
        });
        target = url.href;
      }
      if (current !== target) { written.set(link, target); link.setAttribute('href', target); }
    });
  };
  scan();
  new MutationObserver(scan).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true,
    attributeFilter: ['href', 'data-utm-source', 'data-utm-medium', 'data-utm-campaign', 'data-store-url']
  });
})();
